export enum CapEnum {
  CAP_NOT_INITIATED = "1_CAP_Not_Initiated",
  CAP_IN_PROGRESS = "2_CAP_In_Progress",
  CUSTOMER_ACCEPTED = "3_Customer_Accepted",
  CUSTOMER_NOT_ACCEPTED = "4_Customer_not_Accepted",
  CAP_WILL_EXPIRE_SOON = "5_CAP_will_expire_soon",
  CAP_EXPIRED = "6_CAP_is_expired",
  ESIGN_NOT_COMPLETED = "7_ESIGN_not_completed"
}
export enum VerificationStatus {
  NOT_VERIFIED = "1_not_verified",
  VERIFIED = "2_verified"
}

export enum StatusIdentification {
  COMPLETED = "Completed",
  INPROGRESS = "InProgress",
  NOTASSIGNED = "NotAssigned",
  ESIGN_NOT_COMPLETED = "ESignNotCompleted"
}
export enum IdCardStatus {
  MISSINGINFO = "1_missingInfo",
  EXPIRED = "2_expired",
  RENEWAL = "3_renewal",
  COMPLETED = "4_completed"
}

export enum IdCardDisplayStatus {
  MISSING_CARD = "missing_card",
  MISSING_DATE = "missing_date",
  EXPIRED = "expired",
  RENEWAL = "renewal",
  VALID = "valid"
}
